module.exports = __webpack_public_path__ + "static/img/pam.15ea798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pam.png
// module id = anpS
// module chunks = 0